import { CheckCircle, Award, Users, Target } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";

export const About = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-slate-50 to-blue-50 py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Sobre a ForrosPro
              </h1>
              <p className="text-lg text-gray-600 mb-4">
                Há mais de 15 anos no mercado, a ForrosPro é referência em
                instalação de forros e acabamentos de alta qualidade. Nossa
                missão é transformar ambientes com soluções que unem estética,
                funcionalidade e durabilidade.
              </p>
              <p className="text-lg text-gray-600">
                Com uma equipe de profissionais especializados e comprometidos
                com a excelência, atendemos clientes residenciais e comerciais
                em toda a região metropolitana, garantindo satisfação em cada
                projeto executado.
              </p>
            </div>
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80"
                alt="Equipe ForrosPro"
                className="rounded-lg shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Nossos Valores
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Princípios que guiam nosso trabalho e relacionamento com clientes
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <Card className="text-center hover:shadow-lg transition-shadow">
              <CardContent className="p-6">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 text-blue-600 rounded-full mb-4">
                  <CheckCircle size={32} />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Qualidade
                </h3>
                <p className="text-gray-600">
                  Compromisso com os mais altos padrões de qualidade em cada
                  projeto
                </p>
              </CardContent>
            </Card>

            <Card className="text-center hover:shadow-lg transition-shadow">
              <CardContent className="p-6">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 text-green-600 rounded-full mb-4">
                  <Users size={32} />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Transparência
                </h3>
                <p className="text-gray-600">
                  Comunicação clara e honesta em todas as etapas do serviço
                </p>
              </CardContent>
            </Card>

            <Card className="text-center hover:shadow-lg transition-shadow">
              <CardContent className="p-6">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-purple-100 text-purple-600 rounded-full mb-4">
                  <Target size={32} />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Pontualidade
                </h3>
                <p className="text-gray-600">
                  Cumprimento rigoroso de prazos acordados com nossos clientes
                </p>
              </CardContent>
            </Card>

            <Card className="text-center hover:shadow-lg transition-shadow">
              <CardContent className="p-6">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-100 text-orange-600 rounded-full mb-4">
                  <Award size={32} />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Excelência
                </h3>
                <p className="text-gray-600">
                  Busca contínua pela melhoria e superação das expectativas
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl md:text-5xl font-bold text-blue-600 mb-2">
                15+
              </div>
              <p className="text-lg text-gray-600">Anos de Experiência</p>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-blue-600 mb-2">
                500+
              </div>
              <p className="text-lg text-gray-600">Projetos Concluídos</p>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-blue-600 mb-2">
                98%
              </div>
              <p className="text-lg text-gray-600">Satisfação dos Clientes</p>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-bold text-blue-600 mb-2">
                20+
              </div>
              <p className="text-lg text-gray-600">Profissionais Qualificados</p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Nossa Missão
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed">
              Proporcionar soluções em forros e acabamentos que transformem
              ambientes, agregando valor aos imóveis de nossos clientes através
              de serviços de qualidade superior, executados por profissionais
              capacitados e com total comprometimento com prazos e excelência.
            </p>
          </div>

          <div className="bg-blue-50 rounded-lg p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
              Áreas Atendidas
            </h3>
            <p className="text-lg text-gray-600 text-center">
              Atendemos toda a região metropolitana de São Paulo e Grande ABC,
              levando qualidade e profissionalismo até você. Entre em contato
              para verificar disponibilidade em sua área.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
